import { Button } from "@/components/ui/button";
import { ArrowRight, Sparkles } from "lucide-react";

export const CTA = () => {
  return (
    <section className="py-24 relative overflow-hidden" aria-labelledby="cta-title">
      {/* Animated Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-background via-muted to-background" aria-hidden="true" />
      <div className="absolute inset-0" aria-hidden="true">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary/20 rounded-full blur-[120px] animate-glow-pulse" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-secondary/20 rounded-full blur-[120px] animate-glow-pulse" style={{ animationDelay: '1s' }} />
      </div>
      
      <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8">
        <article className="max-w-4xl mx-auto text-center space-y-8 animate-fade-in">
          {/* Main Content */}
          <header className="space-y-6">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-card/50 border border-border backdrop-blur-sm">
              <Sparkles className="w-4 h-4 text-primary" aria-hidden="true" />
              <span className="text-sm font-medium text-muted-foreground">Join the Community</span>
            </div>
            
            <h2 id="cta-title" className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight">
              Ready to{" "}
              <span className="text-gradient">Transform Your Productivity?</span>
            </h2>
            
            <p className="text-lg sm:text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
              CSW transforms studying and working from a solitary chore into a supportive, engaging experience. By combining live study rooms, structured productivity tools and a thriving global community, CSW helps you stop procrastinating, stay accountable and boost your output. Whether you're chilling, studying or working, there's a place for you here – and research backs up the benefits of learning together.
            </p>
            
            <p className="text-xl font-semibold text-foreground">
              Ready to join? Jump into a room, set your goals and start transforming your productivity today.
            </p>
          </header>
          
          {/* CTA Buttons */}
          <nav className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center w-full px-4 sm:px-0" aria-label="Call to action">
            <Button 
              size="lg"
              className="group bg-primary hover:bg-primary/90 text-primary-foreground font-semibold px-6 sm:px-10 py-5 sm:py-7 text-lg sm:text-xl glow-primary transition-all hover:scale-105 w-full sm:w-auto"
              asChild
            >
              <a href="https://app.csw.live" target="_blank" rel="noopener noreferrer">
                Start Now – It's Free
                <ArrowRight className="ml-2 h-5 sm:h-6 w-5 sm:w-6 group-hover:translate-x-1 transition-transform" />
              </a>
            </Button>
            <Button 
              size="lg"
              variant="outline"
              className="border-2 border-border hover:bg-card font-semibold px-6 sm:px-10 py-5 sm:py-7 text-lg sm:text-xl transition-all hover:scale-105 w-full sm:w-auto"
              asChild
            >
              <a href="https://app.csw.live" target="_blank" rel="noopener noreferrer">
                Watch How It Works
              </a>
            </Button>
          </nav>
          
          {/* Trust Indicators */}
          <aside className="pt-8 space-y-4 animate-fade-in" style={{ animationDelay: '0.2s' }} aria-label="Trusted by">
            <p className="text-sm text-muted-foreground uppercase tracking-wider font-semibold">
              Trusted by students worldwide
            </p>
            <ul className="flex flex-wrap justify-center items-center gap-8 opacity-60" aria-label="User categories">
              {['University Students', 'Professionals', 'Creators', 'Researchers'].map((group) => (
                <li key={group} className="text-muted-foreground font-medium">
                  {group}
                </li>
              ))}
            </ul>
          </aside>
        </article>
      </div>
    </section>
  );
};
